"use client";

import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Item, ItemAvatar, ItemContent } from "@opensea/next-ui-kit";
import { FlexCenter, FlexColumn, Markdown, Modal, ModalBody, ModalHeader } from "@opensea/ui-kit";
import { SocialLinks } from "@/components/social/SocialLinks";
import { getValidUrl } from "@/lib/helpers/url";
import { CollectionInfoFragment } from "./CollectionInfo";
export function CollectionDescriptionModal(t0) {
  const $ = _c(39);
  let collectionKey;
  let open;
  let rest;
  if ($[0] !== t0) {
    ({
      collection: collectionKey,
      open,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = collectionKey;
    $[2] = open;
    $[3] = rest;
  } else {
    collectionKey = $[1];
    open = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== collectionKey) {
    t1 = readFragment(CollectionInfoFragment, collectionKey);
    $[4] = collectionKey;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const collection = t1;
  if (!collection) {
    return null;
  }
  if (!collection.description) {
    return null;
  }
  let t2;
  if ($[6] !== collection.imageUrl) {
    t2 = collection.imageUrl ? <div className="relative inline-block shrink-0"><ItemAvatar className="rounded" size={80} src={collection.imageUrl} /><div className="absolute inset-0 inset-shadow-border rounded" /></div> : null;
    $[6] = collection.imageUrl;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CollectionLockupContent><CollectionLockupTitle weight="semibold" /></CollectionLockupContent>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== collection) {
    t4 = <FlexCenter className="gap-2"><CollectionLockup collection={collection} size="2xl">{t3}</CollectionLockup></FlexCenter>;
    $[9] = collection;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== collection.externalUrl) {
    t5 = collection.externalUrl ? <SocialLinks.Website href={getValidUrl(collection.externalUrl)} /> : null;
    $[11] = collection.externalUrl;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== collection.twitterUsername) {
    t6 = collection.twitterUsername ? <SocialLinks.Twitter username={collection.twitterUsername} /> : null;
    $[13] = collection.twitterUsername;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== collection.instagramUsername) {
    t7 = collection.instagramUsername ? <SocialLinks.Instagram username={collection.instagramUsername} /> : null;
    $[15] = collection.instagramUsername;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== collection.discordUrl) {
    t8 = collection.discordUrl ? <SocialLinks.Discord href={collection.discordUrl} /> : null;
    $[17] = collection.discordUrl;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <FlexCenter className="gap-2">{t5}{t6}{t7}{t8}</FlexCenter>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t4 || $[25] !== t9) {
    t10 = <ItemContent><FlexColumn className="w-full gap-2">{t4}{t9}</FlexColumn></ItemContent>;
    $[24] = t4;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t2) {
    t11 = <ModalHeader className="border-b-0"><Item variant="unstyled">{t2}{t10}</Item></ModalHeader>;
    $[27] = t10;
    $[28] = t2;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== collection.description) {
    t12 = <ModalBody><Markdown>{collection.description}</Markdown></ModalBody>;
    $[30] = collection.description;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t11 || $[33] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== open || $[36] !== rest || $[37] !== t13) {
    t14 = <Modal content={t13} open={open} {...rest} />;
    $[35] = open;
    $[36] = rest;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
}